import { Dialog, DialogContent, Box, DialogActions, FormHelperText, Button, Alert, IconButton, DialogTitle, Divider } from '@mui/material';
import { setArticleFolderDetailsData } from '../../../redux/articleFolderDetailsDataSlice';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import axios from 'axios';
import { cleanRichText } from '../../../utils/richText';
import RichTextEditor from '../../richText/RichTextEditor';
import useContentFormDialog from '../../richText/useContentFormDialog';
import '../../../css/users/addUserDialog.css';

export const UpdateArticleFolderDescription = ({ modifyDescription, setModifyDescription }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const articleFolderDetailsData = useSelector((state) => state.ArticleFolderDetailsData);
    const dialogProps = useContentFormDialog();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            description: articleFolderDetailsData?.description || '',
        },
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`article-folder/${articleFolderDetailsData.id}`, {
                    description: cleanRichText(values.description),
                });
                if (response.status === 200 || response.status === 201) {
                    dispatch(setArticleFolderDetailsData({ ...articleFolderDetailsData, description: response.data.description }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier la description de dossier" }));
                    setModifyDescription(false);
                }
            } catch (error) {
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification de la description de dossier');
                console.error('Error updating folder description:', error);
            }
        },
    });

    const { handleSubmit, values, setFieldValue } = formik;

    const handleClose = () => setModifyDescription(false);

    return (
        <Dialog open={modifyDescription} {...dialogProps}>
            <IconButton onClick={handleClose} className='addUser_icon_button'>
                <Iconify icon={"material-symbols:close"} className='addUser_close_icon' />
            </IconButton>
            <DialogTitle className='addUser_dialog_title'>{t("Modifier la description de dossier")}</DialogTitle>
            <Divider />
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form className='contentFormDialog_form' onSubmit={handleSubmit}>
                <DialogContent className='addUser_dialog_content contentFormDialog_content'>
                    <Box className="addUser_helper_selct_box contentFormDialog_description">
                        <FormHelperText className="addUserInputTitle">{t('Description')}</FormHelperText>
                        <RichTextEditor
                            value={values.description}
                            onChange={(html) => setFieldValue('description', html)}
                            placeholder={t('Description')}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addUser_dialog_actions'>
                    <Button className='addUser_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addUser_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
